import { useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { IoClose } from 'react-icons/io5'
import { field } from '../../../utils/cms'
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher'
import './MobileMenu.css'

const MobileMenu = ({
  isOpen,
  onClose,
  navbar,
  links = [],
  logo,
  ctaLabel,
  ctaUrl,
}) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  if (!navbar) return null

  return (
    <div
      id="mobile-menu"
      className={`mobile-menu${isOpen ? ' is-open' : ''}`}
      aria-hidden={!isOpen}
    >
      <header className="mobile-menu__header">
        <Link to="/" className="mobile-menu__logo-link" onClick={onClose}>
          {logo ? (
            <img src={logo} alt="Tevris" className="mobile-menu__logo" />
          ) : null}
        </Link>
        <button
          type="button"
          className="mobile-menu__close"
          onClick={onClose}
          aria-label={field(navbar, 'closeMenuLabel')}
        >
          <IoClose aria-hidden />
        </button>
      </header>

      <div className="mobile-menu__body">
        <nav className="mobile-menu__nav" aria-label="Mobile navigation">
          {links.map(({ label, url, index }) => (
            <NavLink
              key={`${url}-${index}`}
              className={({ isActive }) =>
                `mobile-menu__link${isActive ? ' mobile-menu__link--active' : ''}`
              }
              to={url || '/'}
              end={url === '/'}
              onClick={onClose}
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <hr className="mobile-menu__divider" />

        <footer className="mobile-menu__footer">
          <div className="mobile-menu__language-wrap">
            <LanguageSwitcher />
          </div>
          <Link to={ctaUrl || '/contact'} className="navbar-cta" onClick={onClose}>
            {ctaLabel}
          </Link>
        </footer>
      </div>
    </div>
  )
}

export default MobileMenu
